export default __webpack_public_path__ + "static/decorist-8-c-5f6ae755730c52ac1d8bf117251bf7f4.webp";